// @flow

import { type Country } from '@tectonics/prs/country';
import { translateErrorMessagePT } from './error-messages-pt';
import { translateErrorMessageES } from './error-messages-es';
import { translateErrorMessageEN } from './error-messages-en';

export function getTranslateErrorMessage(country: Country): (string) => ?string {
  switch (country) {
    case 'br':
      return translateErrorMessagePT;
    case 'ar':
    case 'bo':
    case 'ec':
    case 'cl':
    case 'co':
    case 'mx':
    case 'pe':
    case 'uy':
    case 'py':
    case 'pa':
    case 'sv':
    case 'gt':
    case 'do':
    case 'cr':
      return translateErrorMessageES;

    case 'za':
    case 'ke':
    case 'ng':
    case 'in':
    case 'tz':
    case 'ug':
    case 'zm':
    case 'eg':
    case 'gh':
    case 'jm':
      return translateErrorMessageEN;

    default:
      throw new Error(`getTranslateErrorMessage - country ${country} translate messages not supported`);
  }
}
